import OpenIdConnectService from 'core/services/open-id-connect';
import { concat } from '@ember/helper';
import templateOnly, { TOC } from '@ember/component/template-only';
import WrLinkTo from 'ember-wiser/components/wr/link-to';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const AuthenticationOpenIdConnectButtonComponent = setComponentTemplate(precompileTemplate("\n  {{#if @openIdConnectService.isEnabled}}\n    <div data-test-open-id-connect={{@openIdConnectService.issuer}} ...attributes>\n      <WrLinkTo @route={{@openIdConnectService.route}} class=\"w-full\">\n        <img src={{@openIdConnectService.imageUrl}} alt={{concat @openIdConnectService.label \" Identification\"}} />\n      </WrLinkTo>\n    </div>\n  {{/if}}\n", {
  strictMode: true,
  scope: () => ({
    WrLinkTo,
    concat
  })
}), templateOnly(undefined, "open-id-connect-button:AuthenticationOpenIdConnectButtonComponent"));
export default AuthenticationOpenIdConnectButtonComponent;